import React, { useEffect, useState } from "react";
import "./Shahada.css";
import { Link } from "react-router-dom";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
const Shahada = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  setTimeout(() => {
    var bodyWidth = document.querySelector("body").clientWidth;
    if (bodyWidth < 800) {
      document.querySelector(
        ".rh5v-DefaultPlayer_component"
      ).style.width = `${bodyWidth}px`;
    }
  }, 1000);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      {/* <div>
                <div class="wrapper" id="cover">
                    <img
                        src={require("../../../Assets/images/cover-shahadaa.png")}
                        class="prx"
                        style={{ height: "250px", width: "100%" }}
                    />
                    <h1>Shahada</h1>
                </div>
            </div> */}
      <section style={{ marginBottom: "60px" }}>
        <div class="pbloc">
          <div class="fbloc">
            <img
              src={require("../../../Assets/images/prayer-thumbnail.png")}
              alt="prayer"
              class="prayer"
            />
            <h1>
              {rtl
                ? `إعلان الإيمان (الشهادة في الإسلام)`
                : fr
                ? "LA DÉCLARATION DE FOI (Shahada)"
                : `The declaration of faith (Shahada)`}
            </h1>
            <p>
              {rtl
                ? `يحدد إعلان الإيمان الهوية الأساسية للمسلمين - إيمانهم ومعتقداتهم وممارساتهم
- ويربط معا مجتمعا عالميا من المؤمنين

لهم قيم واهتمامات مشتركة. هذا تذكير دائم بأهمية الله في حياتنا.`
                : fr
                ? `La déclaration de foi définit l'identité fondamentale des musulmans - leur foi,
                leurs croyances et leurs pratiques - et lie une communauté mondiale de
                croyants en une communauté de valeurs et de préoccupations communes.
                C'est un rappel constant de l'importance de Dieu dans notre vie.`
                : ` The declaration of faith define the basic identity
                            of Muslims - their faith, beliefs and practices -
                            and bind together a worldwide community of believers
                            into a fellowship of shared values and concerns.
                            This is a constant reminder of the importance of God
                            in our life.`}
            </p>
            {rtl ? (
              <p>
                ولهذا السبب تعد <b> مكة والمدينة القابضة </b>
                أول الشركات القابضة التي بنت رؤيتها ورسالتها وقيمها على أساس
                أركان الإسلام الخمسة، لأنها الالتزامات التي يجب على المسلمين
                الوفاء بها ليعيشوا حياة جيدة ومسؤولة وأن يقربوا من الله.
              </p>
            ) : fr ? (
              <p>
                C'est pourquoi <b>Mecque & la Médine Holdings</b> est la
                première société qui a construit sa vision, sa mission et ses
                valeurs sur la base des cinq piliers de l'islam, car il s'agit
                des obligations que les musulmans doivent satisfaire pour mener
                une vie bonne et responsable et pour se rapprocher de Dieu.
              </p>
            ) : (
              <p>
                That’s why <b>Makkah & Al Madinah Holdings</b> is the first
                holdings who built their vision, mission and values based on the
                Five Pillars of Islam, because they are the obligations that
                Muslims must satisfy to live a good and responsible life and to
                bring them closer to God.
              </p>
            )}
            <p>
              {rtl
                ? `القراء الجيدون يحددون درس أو أخلاقية الشهادة في الحياة ، ولهذا السبب ، فإن
فلسفتنا تستند أيضا إلى البيان الأساسي للعقيدة الإسلامية ، ونحن نعمل معا
لأسباب وأهداف مشتركة ، والسبب في كوننا في خدمة الآخرين هو واجبنا ،
ولهذا السبب يعمل فريق مكة والمدينة القابضة معا لإنشاء نهج استراتيجي
لأعمالهم الخيرية من أجل إحداث تأثير حقيقي على المجتمع.`
                : fr
                ? `Les bons lecteurs déterminent la leçon ou la morale de la Shahada dans la vie,
                c'est pourquoi, notre philosophie basée également sur la déclaration de base
                de la foi islamique, nous travaillons ensemble pour des raisons et des objectifs
                communs, la raison d'être au service des autres est notre devoir, pour cette
                raison l'équipe de MMH travaille ensemble pour créer une approche
                stratégique de leur philanthropie afin d'avoir un impact réel sur la société.`
                : `Good readers determine the lesson or moral of
                            Shahada in life, that’s why, our philosophy based
                            also on the basic statement of the Islamic faith, we
                            are working together for common reasons and goals,
                            the reason of being in service to others is our
                            duty, for that reason MMH team work together to
                            create a strategic approach to their philanthropy in
                            order to make a real impact on society.`}
            </p>
          </div>
          <div class="sbloc">
            <Video
              // autoPlay
              // loop
              muted
              controls={["PlayPause", "Seek", "Time", "Volume", "Fullscreen"]}
              poster={require("../../../Assets/images/shahada-capture.png")}
              onCanPlayThrough={() => {
                // Do stuff
              }}
            >
              <source
                src={require("../../../Assets/shahada.mp4")}
                type="video/mp4"
              />
              <track
                label="English"
                kind="subtitles"
                srcLang="en"
                src="http://source.vtt"
                default
              />
            </Video>
          </div>
        </div>
      </section>
      <div class="container">
        <div class="plrs-wrap text-center remove-ext5">
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div class="col-md-3 col-sm-6 col-lg-2 plrs ">
              <Link to="/five-pillars-shahada">
                <div class="plr-box ">
                  <i class="flaticon-clicker"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الشهادتان` : `Shahadah`}</h4>
                    <p>({rtl ? `ايمان` : fr ? "La foi" : `Faith`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-prayer">
                <div class="plr-box">
                  <i class="flaticon-islamic-pray"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إقامِ الصلاةِ` : `Salah`}</h4>
                    <p>({rtl ? `صلاة` : fr ? "Prière" : `Prayer`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-fasting">
                <div class="plr-box">
                  <i class="flaticon-islamic-ramadan"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `صومِ رمضانَ` : `Sawm`}</h4>
                    <p>({rtl ? `صوم` : fr ? "Le jeûne" : `Fasting`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-zakat">
                <div class="plr-box">
                  <i class="flaticon-charity"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إيتاءِ الزّكاةِ` : `Zakat`}</h4>
                    <p>({rtl ? `الصدقة` : fr ? "L'aumône" : `Almsgiving`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 ">
              <Link to="/five-pillars-pilgrimage">
                <div class="plr-box">
                  <i class="flaticon-kaaba-building"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الحجِّ` : `Hajj`}</h4>
                    <p>({rtl ? `حج` : fr ? "Pèlerinage" : `Pilgrimage`})</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Shahada;
